/**
 * Shared wishlist store for Alfa Home Furniture.
 * localStorage-only (no customer/account sync yet).
 *
 * Storage shape: an array of saved product snapshots, so pages like the
 * wishlist page can render without extra API calls:
 *   [{ id, handle, title, image, price, url }, ...]
 *
 * Usage from any section/component:
 *   window.AhfWishlist.isSaved(id)
 *   window.AhfWishlist.toggle(product)
 *   window.AhfWishlist.getAll()
 *   window.AhfWishlist.count()
 *   document.addEventListener('wishlist:change', (e) => { e.detail.items, e.detail.count })
 */
(function () {
  // Guard against this script being included multiple times — it can be
  // pulled in once per product card on a grid page (many cards per page).
  if (window.AhfWishlist) return;

  const STORAGE_KEY = 'ahf-wishlist';

  function read() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (err) {
      console.error('Wishlist read error:', err);
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (err) {
      console.error('Wishlist write error:', err);
    }
    emitChange(items);
  }

  function emitChange(items) {
    document.dispatchEvent(
      new CustomEvent('wishlist:change', {
        detail: { items, count: items.length },
      })
    );
  }

  function isSaved(id) {
    return read().some((item) => String(item.id) === String(id));
  }

  function add(product) {
    const items = read();
    if (items.some((item) => String(item.id) === String(product.id))) return items;
    items.push(product);
    write(items);
    return items;
  }

  function remove(id) {
    const items = read().filter((item) => String(item.id) !== String(id));
    write(items);
    return items;
  }

  function toggle(product) {
    if (isSaved(product.id)) {
      return { items: remove(product.id), saved: false };
    }
    return { items: add(product), saved: true };
  }

  function getAll() {
    return read();
  }

  function count() {
    return read().length;
  }

  window.AhfWishlist = { isSaved, add, remove, toggle, getAll, count };

  // Let any already-rendered UI (e.g. a header badge) sync on first paint.
  document.addEventListener('DOMContentLoaded', () => emitChange(read()));
})();